import {createStyles, makeStyles} from '@material-ui/core/styles/';

export const useStyles = makeStyles(() => {
  return createStyles({
    wrapperBox: {
      marginTop: '18px'
    },
    iconImage: {
      objectFit: 'contain',
      height: '28px',
      width: '28px'
    },
    homeContainer: {
      display: 'flex',
      flexDirection: 'row'
    },
    subHeading: {
      marginTop: '20px',
      marginBottom: '8px'
    },
    alertMessage: {
      marginLeft: '10px !important',
      marginBottom: '20px !important'
    }
  });
});
